<template>
    <section id="items">
        <SiteHeader></SiteHeader>
        <ExplorerListItems></ExplorerListItems>
        <SiteFooter></SiteFooter>
    </section>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import ExplorerListItems from '@/components/ExplorerListItems.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
    name: 'Explorer',
    metaInfo: {
        title: 'Explorer'
    },
    components: {
        SiteHeader,
        ExplorerListItems,
        SiteFooter
    }
}
</script>